<template>
  <ca-table class="ca-u-min-margin-top">
    <ca-tr slot="header">
      <ca-th></ca-th>
      <ca-th>Código</ca-th>
      <ca-th>Hr entrada</ca-th>
      <ca-th>Hr saída</ca-th>
      <ca-th>Duração</ca-th>
      <ca-th>Intervalo</ca-th>
      <ca-th></ca-th>
    </ca-tr>
    <ca-tr v-for="(shift, index) in shiftInfo.associatedWorkshifts" :key="index">
      <ca-td>
        {{ codeDays[shift.weekDay.name] }}
      </ca-td>
      <template v-if="shift.workshift">
        <ca-td>
          {{ shift.workshift.code }}
        </ca-td>
        <ca-td>
          {{ shift.workshift.checkInTime }}
        </ca-td>
        <ca-td>
          {{ shift.workshift.checkOutTime }}
        </ca-td>
        <ca-td>
          {{ `${shift.workshift.workingHours} horas` }}
        </ca-td>
        <ca-td>
          {{ getIntervalDuration(shift.workshift) }}
        </ca-td>
        <ca-td>
          <ca-button
            :full-width="true"
            size="small"
            @click="onDelete(shift)">
            Excluir
          </ca-button>
        </ca-td>
      </template>

      <template v-else>
        <ca-td>
          <ca-badge theme="success">Livre</ca-badge>
        </ca-td>
        <ca-td colspan="4"></ca-td>
        <ca-td>
          <ca-button
            :full-width="true"
            size="small"
            @click="onSelect(shift)">
            Selecionar
          </ca-button>
        </ca-td>
      </template>
    </ca-tr>
  </ca-table>
</template>

<script>
import CreateShiftModal from '../modals/CreateShiftModal';
import { getIntervalDuration, deleteWorkerShift } from '../../../workersService';
import { deleteWorkerShiftFromDraft } from '../workerShiftInfoService';
import { CODE_DAYS } from '../../../workerConstants';

export default {
  name: 'WorkerShiftTable',
  props: {
    shiftInfo: Object,
    isDraft: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      codeDays: CODE_DAYS,
    };
  },
  computed: {
    workerId() {
      return this.$store.state.worker?.basicInfo?.id;
    },
  },
  mounted() {
    this.checkWeeklyHours();
  },
  methods: {
    getIntervalDuration,
    checkWeeklyHours() {
      if (Array.isArray(this.shiftInfo?.associatedWorkshifts)) {
        const hasWorkerShift = this.shiftInfo.associatedWorkshifts.some(time => time?.workshift);

        if (!hasWorkerShift) {
          this.$emit('clear-weekly-hours');
        }
      }
    },
    onDelete(shift) {
      this.$caConfirm({
        title: 'Confirmação de exclusão',
        message: 'Deseja realmente excluir este turno?',
        onConfirm: async () => {
          try {
            if (this.isDraft) {
              deleteWorkerShiftFromDraft(shift.weekDay.name);
            } else {
              await deleteWorkerShift(this.workerId, shift.weekDay.name);
            }
            this.$toaster.success('Turno excluído com sucesso!');
            this.$emit('shift-deleted');
          } catch (err) {
            this.$toaster.error('Não foi possível excluir o turno informado. Tente novamente.');
          }
        },
      });
    },
    onSelect(shift) {
      this.$dialogModal(CreateShiftModal, {
        props: {
          selectedDay: shift.weekDay.name,
          isDraft: this.isDraft,
          workerId: this.workerId,
        },
        on: {
          'shift-added': () => this.$emit('shift-added'),
        },
      }).open();
    },
  },
};
</script>
